import { render, staticRenderFns } from "./ConnectionSummary.vue?vue&type=template&id=66540e72"
import script from "./ConnectionSummary.vue?vue&type=script&lang=js"
export * from "./ConnectionSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports